import { useEffect, useMemo, useRef, useState } from 'react';
import InputBox from '../../../component/InputBox';
import SelectionBox from '../../../component/SelectionBox';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import EnrolmentStatusSubjectModal from '../../modal/EnrolmentStatusSubjectModal';
import { modalType } from '../../../util/ModalUtil';
import ModalRef from '../../../component/ModalRef';
import { useDispatch, useSelector } from 'react-redux';
import { actionSearch } from '../../../module/body/semester/SemesterEnrolmentStatusViewTab2BodyModule';
import { actionExcelDownload } from '../../../module/body/semester/SemesterTotalEnrolmentStatusModule';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import { IconButton, Tooltip } from '@material-ui/core';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import TableBox from '../../../component/TableBox';
import { handleControl, defaultGridData, initGrid } from '../../../module/component/TableBoxModule';
import StatusTextIconBox from '../../../component/StatusTextIconBox';
import { OpenDetailIcon } from '../../../component/icon/GridIcons';
import PathUtil from '../../../util/PathUtil';
import FormatUtil from '../../../util/FormatUtil';

import qs from 'qs';
import { useLocation } from 'react-router-dom';
import NullCheckUtil from '../../../util/NullCheckUtil';
import PopupRef from '../../../component/PopupRef';
import { VIEW_SEMESTER_TOTAL_ENROLMENT_STATUS } from './../../../constant/ViewConstant';
import BreadCrumb from '../../../component/BreadCrumb';

const ConditionArea = ({ tabNo, popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const [semesterId, setSemesterId] = useState(SessionStorageUtil.getCurrentSemesterId());
    const [lessonUniversityCd, setLessonUniversityCd] = useState('');
    const [subjectNm, setSubjectNm] = useState('');
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const [enrolmentRegStatusCd, setEnrolmentRegStatusCd] = useState('');
    const [classNo, setClassNo] = useState('');
    const [userNm, setUserNm] = useState('');
    const [params, setParams] = useState({});

    const { gridData } = useSelector((state) => state.tableBoxState);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.userUniversityCd && setUserUniversityCd(queryData.userUniversityCd);
        queryData.enrolmentRegStatusCd && setEnrolmentRegStatusCd(queryData.enrolmentRegStatusCd);
        queryData.subjectNm && setSubjectNm(queryData.subjectNm);
        queryData.userNm && setUserNm(queryData.userNm);

        onClick({
            semesterId,
            lessonUniversityCd,
            userUniversityCd: queryData.userUniversityCd,
            enrolmentRegStatusCd: queryData.enrolmentRegStatusCd,
            subjectNm: queryData.subjectNm,
            userNm: queryData.userNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 100,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClick({
            ...params,
            page,
            pageSize,
        });
    };

    const onClick = (params) => {
        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, { ...params, tabNo });
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <EnrolmentStatusSubjectModal
                row={row}
                type={modalType.DETAIL}
                modalRef={modalRef}
                callback={() => {
                    onClick(params);
                }}
            />,
            'medium',
        );
    };

    const handleDownload = () => {
        dispatch(actionExcelDownload({ params }));
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClick({
                semesterId,
                lessonUniversityCd,
                userUniversityCd,
                enrolmentRegStatusCd,
                subjectNm,
                classNo,
                userNm,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'semesterId',
                headerName: '학기',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 14,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SEMESTER, params.row.semesterId),
            },
            {
                field: 'lessonUniversityCd',
                headerName: '개설대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, params.row.lessonUniversityCd),
            },
            {
                field: 'subjectNm',
                headerName: '교과목',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 20,
            },
            { field: 'classNo', headerName: '분반', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'profNm', headerName: '교강사', headerAlign: 'center', align: 'center', tooltip: true, flex: 8 },
            { field: 'creditCnt', headerName: '학점', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            {
                field: 'userUniversityCd',
                headerName: '소속대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd),
            },
            {
                field: 'majorDeptNm',
                headerName: '소속대학 전공(학과)',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'studentId',
                headerName: '소속대학 학번',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },

            {
                field: 'userId',
                headerName: '사용자ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'telNo',
                headerName: '연락처',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => FormatUtil.phoneFormatter(params.row.telNo),
            },
            // {
            //     field: 'enrolmentRegDttm',
            //     headerName: '수강신청일시',
            //     headerAlign: 'center',
            //     align: 'center',
            //     tooltip: true,
            //     flex: 15,
            // },
            {
                field: 'enrolmentRegStatusCd',
                headerName: '수강등록상태',
                headerAlign: 'center',
                align: 'center',
                // tooltip: true,
                flex: 12,
                renderCell: (params) => (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_REG_STATUS}
                        statusCd={params.row.enrolmentRegStatusCd}
                    />
                ),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 6,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <div className='tab-body'>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => setSemesterId(e.target.value)}
                                    useAll={true}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='개설대학'
                                    w140
                                    value={lessonUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    onChange={(e) => setLessonUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='교과목'
                                    value={subjectNm}
                                    onChange={(e) => setSubjectNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='분반'
                                    value={classNo}
                                    size='small'
                                    onChange={(e) => setClassNo(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='소속대학'
                                    w140
                                    value={userUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                    onChange={(e) => setUserUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='이름'
                                    value={userNm}
                                    size='medium'
                                    onChange={(e) => setUserNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='수강등록상태'
                                    w140
                                    value={enrolmentRegStatusCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_REG_STATUS)}
                                    onChange={(e) => setEnrolmentRegStatusCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClick({
                                            semesterId,
                                            lessonUniversityCd,
                                            userUniversityCd,
                                            enrolmentRegStatusCd,
                                            subjectNm,
                                            classNo,
                                            userNm,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>수강신청 현황</h3>
                    <div className='btn-group'>
                        <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                    </div>
                </div>
                <div className='comment-box'>
                    <ul>
                        <li>전체 수강신청 현황 데이터를 확인할 수 있습니다.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

const SemesterTotalEnrolmentStatusView = ({ tabNo }) => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg03'>
                    <h2 className='con-title'>{VIEW_SEMESTER_TOTAL_ENROLMENT_STATUS.title}</h2>
                    <p className='con-title-p'>{VIEW_SEMESTER_TOTAL_ENROLMENT_STATUS.subTitle}</p>
                </div>
                <div className='sub-nav-wrap h-44'>
                    <div className='sub-nav-box'>
                        <BreadCrumb />
                    </div>
                </div>
                <div>
                    <ConditionArea tabNo={tabNo} popupRef={popupRef} modalRef={modalRef} />
                    <TableBox />
                    <PopupRef ref={popupRef} />
                    <ModalRef ref={modalRef} />
                </div>
            </div>
        </section>
    );
};

export default SemesterTotalEnrolmentStatusView;
